import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { LoadMixerPremix } from '../../../store/application/loadMixers/loadMixers.types';
import { APIManagerConfig } from '../apiManager';

const PremixServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getPremixList: (): Promise<any> =>
      HTTPBase.get(`farm/${config.farmId}/rations?filter=premix&includedetails=true`).then((res) => res.data),
    getPremix: (premixId): Promise<any> =>
      HTTPBase.get(`farm/${config.farmId}/rations/${premixId}`).then((res) => res.data),
    createPremix: (payload, formName: FormName): Promise<any> =>
      HTTPBase.post(`farm/${config.farmId}/rations`, payload, { headers: { formName } }).then((res) => res.data),
    simulateCreatePremix: (payload): Promise<any> =>
      HTTPBase.post(`farm/${config.farmId}/rations?nosave=true`, payload).then((res) => res.data),
    editPremix: (premixId, payload, formName: FormName): Promise<any> =>
      HTTPBase.patch(`farm/${config.farmId}/rations/${premixId}`, payload, { headers: { formName } }).then(
        (res) => res.data,
      ),
    simulateEditPremix: (premixId, payload): Promise<any> =>
      HTTPBase.patch(`farm/${config.farmId}/rations/${premixId}?nosave=true`, payload).then((res) => res.data),
    deletePremix: (premixId, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/rations/${premixId}`, { headers: { formName } }).then((res) => res.data),
    getPremixesInLoadMixer: (): Promise<LoadMixerPremix[]> =>
      HTTPBase.get(`farm/${config.farmId}/premixes`).then((res) => res.data),
  };
};

export default PremixServiceFactory;
